import { useMemo } from 'react';

import { getFilterOptions } from '../../../helpers/filter';

import { BLANK_FILTER_TEXT } from '../../../constants/livestock';

export const useFilterOptions = data => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        batteryStatuses: [],
        connectionStatuses: [],
        farms: [],
        linkedStatuses: [],
        locations: []
      };
    }

    return {
      batteryStatuses: getFilterOptions(data, 'battery_status_label'),
      connectionStatuses: getFilterOptions(data, 'status'),
      farms: getFilterOptions(data, 'farm_name'),
      linkedStatuses: [...new Set(data?.map(d => (d.animal ? 'Linked' : 'Not Linked')))].map(geofence => ({
        text: geofence,
        value: geofence
      })),
      locations: [...new Set(data?.map(d => (d.animal ? d.animal?.geofences?.at(0)?.name : BLANK_FILTER_TEXT)))].map(
        geofence => ({ text: geofence, value: geofence })
      )
    };
  }, [data]);
};
